const getGMTTime = () => new Date(new Date().toGMTString()).getTime();

export const getSortOrderRank = index => {
  return getGMTTime() - 1e6 + 1000 * index;
};

export const calculateSortOrderRank = (images, targetIndex, insertAtBoundary = false) => {
  if (!images || images.length === 0) {
    return getSortOrderRank(1);
  }

  if (insertAtBoundary) {
    if (targetIndex === 0) {
      return images[0].metadata.sortOrderRank - 1000;
    } else if (targetIndex >= images.length) {
      return images[images.length - 1].metadata.sortOrderRank + 1000;
    }
  }

  const prevImage = images[targetIndex - 1];
  const nextImage = images[targetIndex + 1] || (insertAtBoundary ? null : images[targetIndex]);

  if (!prevImage && !nextImage) {
    return getSortOrderRank(1);
  } else if (!prevImage) {
    return nextImage.metadata.sortOrderRank - 1000;
  } else if (!nextImage) {
    return prevImage.metadata.sortOrderRank + 1000;
  } else {
    const gap = nextImage.metadata.sortOrderRank - prevImage.metadata.sortOrderRank;

    if (gap < 10) {
      return null;
    }

    return Math.floor((prevImage.metadata.sortOrderRank + nextImage.metadata.sortOrderRank) / 2);
  }
};

export const rebalanceSortOrderRanks = images => {
  const baseTime = getGMTTime() - 1e6;
  return images.map((image, index) => ({
    ...image,
    metadata: {
      ...image.metadata,
      sortOrderRank: baseTime + 1000 * (index + 1)
    }
  }));
};
